module.exports = __webpack_public_path__ + "img/wfzc-icon.78b445e.svg";